import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type SessionService from 'bcl/services/session';
import { findRecord } from '@warp-drive/utilities/json-api';
import type { Store } from '@warp-drive/core';

export default class AuthOrdersShowRoute extends Route {
  @service declare store: Store;
  @service declare session: SessionService;

  async model(attrs) {
    const order = await this.store.request(findRecord('order', attrs.id));
    return {
      order: order.content.data,
      company: this.session.company,
    };
  }
}
